import { Pipeline } from ".";
import {
  Box,
  Button,
  Center,
  Flex,
  Grid,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { Fragment, useEffect, useState } from "react";
import {
  downloadValidationErrors,
  getPipelineRootErrors,
  getPipelineStepTitle,
  getValidationErrors,
  groupStepData,
  uploadValidationErrors,
  ValidationErrorsProps,
  validationErrorsMap,
  openModalChangeUsuario,
} from "./utils";
import { openModalUploadFile } from "../../../modal-upload-file";
import { Toast } from "components/toast";
import { DownloadIcon, SettingsIcon } from "@chakra-ui/icons";
import { UploadIcon } from "components/vectors/upload-icon";
import DynamicTable from "components/dynamic-table";
import { MailingTableRow } from "..";
import { makeEvent } from "services/events";
import { bgError, changeAlfaRGB } from "components/dynamic-table/row-status";
import { PipelineProgress } from "./pipeline-step/progress";

export const PIPELINE_STAGES_WITH_CONTENT = [
  "HIGIENIZACAO",
  "SIMULACAO_PORTABILIDADE",
  "TELEFONIA",
  "DIGITACAO",
];

export function ContentPipelineStage({
  modalData,
  pipelineStage,
  row,
  isCurrentStep,
}: {
  modalData: Pipeline[] | undefined;
  pipelineStage: Pipeline["pipelineStage"];
  row: MailingTableRow;
  isCurrentStep: boolean;
}) {
  let pipelinesWithContent = modalData?.filter((higienizacao) =>
    PIPELINE_STAGES_WITH_CONTENT.includes(higienizacao.pipelineStage)
  );
  const [isLoading, setIsLoading] = useState(false);
  const [validationErrors, setValidationErrors] =
    useState<ValidationErrorsProps>({});

  useEffect(() => {
    if (isCurrentStep) {
      const pipelineTarget = pipelinesWithContent?.find(
        (crr) => crr.pipelineStage === "DIGITACAO"
      );
      if (
        pipelineTarget &&
        pipelineTarget.higienizacaoId &&
        pipelineTarget.pipelineItemId
      ) {
        setIsLoading(true);
        getValidationErrors(
          pipelineTarget.higienizacaoId,
          pipelineTarget.pipelineItemId,
          setIsLoading,
          setValidationErrors
        );
      }
    }
  }, []);

  if (pipelinesWithContent && pipelinesWithContent.length > 0) {
    const pipelineRootErrors = getPipelineRootErrors(pipelinesWithContent);
    const groupedData = groupStepData(pipelinesWithContent, pipelineStage);
    const isEmptyData = Object.keys(groupedData).length === 0;

    if (isEmptyData) return null;

    return (
      <Flex flexDir="column" px="5px" py="10px">
        {/* Nível 1 */}
        {Object.keys(groupedData).map((stageKey, i) => {
          const tipoHigienizacaoTitle = getPipelineStepTitle(
            stageKey as Pipeline["pipelineStage"]
          );
          const group = groupedData[stageKey];

          return (
            <Fragment key={stageKey}>
              {/* Nível 2 */}
              {Object.keys(group).map((keyBanco, i, arr) => {
                const isLast = i + 1 === arr.length;
                const currentGroup = group[keyBanco];
                const currentGroupData = currentGroup.data! as any[];
                const errors =
                  currentGroupData?.filter(({ lastError }) => lastError) || [];
                const messages =
                  currentGroupData?.filter(({ mensagem }) => mensagem) || [];

                let columnsLength = 0;
                // if (successHigienizacaoProgress.length) columnsLength++;
                if (errors.length) columnsLength++;
                if (messages.length) columnsLength++;
                if (Object.keys(validationErrors).length) columnsLength++;

                if (
                  !errors.length &&
                  !messages.length &&
                  !Object.keys(validationErrors).length &&
                  !pipelineRootErrors.length
                )
                  return null;

                return (
                  <Box
                    key={keyBanco}
                    border="1px solid var(--chakra-colors-gray-200)"
                    borderRadius="8px"
                    p="10px"
                    mb={isLast ? "0px" : "10px"}
                  >
                    <Center
                      w="100%"
                      fontSize="16px"
                      fontWeight="semibold"
                      mb="10px"
                    >
                      {tipoHigienizacaoTitle} {currentGroup.title}
                    </Center>
                    <PipelineProgress
                      modalData={modalData}
                      pipelineStage={pipelineStage}
                      currentKeyBanco={keyBanco}
                    />
                    <Grid
                      templateColumns={`repeat(${columnsLength}, 1fr)`}
                      gap="10px"
                    >
                      {errors.length ? (
                        <Box>
                          <DynamicTable
                            size="sm"
                            headerStyle={() => ({
                              bg: changeAlfaRGB(bgError, 0.1),
                              _hover: {},
                            })}
                            columns={[
                              {
                                name: `Tipo de erro`,
                                render: ({ lastError }) => (
                                  <Text>{lastError} </Text>
                                ),
                              },
                              {
                                name: `Quantidade`,
                                render: ({ totalCompleted = 0 }) =>
                                  totalCompleted,
                              },
                            ]}
                            pageSize={4}
                            rows={errors}
                          />
                        </Box>
                      ) : null}

                      {messages.length ? (
                        <Box>
                          <DynamicTable
                            size="sm"
                            headerStyle={() => ({
                              bg: `var(--chakra-colors-gray-100)`,
                              _hover: {},
                            })}
                            columns={[
                              {
                                name: `Mensagens:`,

                                render: ({ mensagem }) => (
                                  <Box>
                                    <Text
                                      dangerouslySetInnerHTML={{
                                        __html: `${mensagem}`,
                                      }}
                                      whiteSpace="normal"
                                      sx={{ br: { fontWeight: "bold" } }}
                                    />
                                  </Box>
                                ),
                              },
                              {
                                name: `Quantidade`,
                                render: ({ totalCompleted = 0 }) =>
                                  totalCompleted,
                              },
                              {
                                name: `Ações`,
                                render: ({ mensagem }) => {
                                  // prettier-ignore
                                  const pipelineStage = pipelinesWithContent?.find((curr) => curr.pipelineStage === stageKey);
                                  if (pipelineStage) {
                                    // prettier-ignore
                                    const filters = JSON.parse(pipelineStage.configJson);
                                    const usuarioDigitacao =
                                      filters.usuarioDigitacao;
                                    const usuarioDigitacaoSenha =
                                      filters.usuarioDigitacaoSenha;
                                    if (
                                      mensagem === "Login ou senha incorreta" &&
                                      usuarioDigitacao &&
                                      usuarioDigitacaoSenha
                                    ) {
                                      return (
                                        <Button
                                          onClick={() => {
                                            // prettier-ignore
                                            openModalChangeUsuario({ pipelineStage, row, usuarioDigitacao, usuarioDigitacaoSenha });
                                          }}
                                          variant="outline"
                                          size="xs"
                                          leftIcon={<SettingsIcon />}
                                        >
                                          Corrigir
                                        </Button>
                                      );
                                    }
                                  }
                                },
                              },
                            ]}
                            pageSize={4}
                            rows={messages}
                          />
                        </Box>
                      ) : null}
                      {Object.keys(validationErrors).length ? (
                        isLoading ? (
                          <Center w="100%" py="10px">
                            <Spinner />
                          </Center>
                        ) : (
                          <Box>
                            <DynamicTable
                              size="sm"
                              headerStyle={() => ({
                                bg: changeAlfaRGB(bgError, 0.1),
                                _hover: {},
                              })}
                              columns={[
                                {
                                  name: `Erro de validação:`,
                                  render: (key) => {
                                    return (
                                      <Box>
                                        <Text>
                                          {validationErrorsMap.get(key)}:
                                        </Text>
                                      </Box>
                                    );
                                  },
                                },
                                {
                                  name: `Quantidade`,
                                  render: (key) => {
                                    const currentValidationError =
                                      validationErrors[
                                        key as keyof typeof validationErrors
                                      ];

                                    return (
                                      <Text>{currentValidationError}</Text>
                                    );
                                  },
                                },
                                {
                                  name: `Ações`,
                                  render: (key) => {
                                    const pipelineTarget =
                                      pipelinesWithContent?.find(
                                        (crr) =>
                                          crr.pipelineStage === "DIGITACAO"
                                      );
                                    return (
                                      <>
                                        {key !== "GENERIC" ? (
                                          <Flex mt="4px">
                                            <Button
                                              mr="6px"
                                              size="xs"
                                              // variant="outline"
                                              leftIcon={
                                                <DownloadIcon
                                                  width="13px"
                                                  height="13px"
                                                />
                                              }
                                              onClick={() =>
                                                downloadValidationErrors(
                                                  pipelineTarget?.higienizacaoId!,
                                                  pipelineTarget?.pipelineItemId!,
                                                  key as keyof ValidationErrorsProps
                                                )
                                              }
                                            >
                                              Baixar CSV
                                            </Button>
                                            <Button
                                              size="xs"
                                              // variant="outline"
                                              leftIcon={
                                                <UploadIcon
                                                  width="15px"
                                                  height="15px"
                                                />
                                              }
                                              onClick={() =>
                                                openModalUploadFile({
                                                  onConfirm: async (file) => {
                                                    try {
                                                      await uploadValidationErrors(
                                                        file,
                                                        pipelineTarget?.higienizacaoId!,
                                                        pipelineTarget?.pipelineItemId!,
                                                        key as keyof ValidationErrorsProps
                                                      );
                                                      makeEvent(
                                                        `mailing-update-${row.id}`
                                                      );
                                                    } catch (e: any) {
                                                      const errorDesc =
                                                        e?.response?.data
                                                          ?.message;
                                                      Toast({
                                                        title:
                                                          "Erro ao fazer upload de arquivo",
                                                        description: errorDesc,
                                                      });
                                                    }
                                                  },
                                                })
                                              }
                                            >
                                              Upload CSV
                                            </Button>
                                          </Flex>
                                        ) : null}
                                      </>
                                    );
                                  },
                                },
                              ]}
                              pageSize={4}
                              rows={Object.keys(validationErrors)}
                            />
                          </Box>
                        )
                      ) : null}

                      {pipelineRootErrors.length ? (
                        <Flex gridArea={`auto / span ${columnsLength}`}>
                          <DynamicTable
                            size="sm"
                            headerStyle={() => ({
                              bg: `var(--chakra-colors-gray-100)`,
                              _hover: {},
                            })}
                            columns={[
                              {
                                name: `Outros:`,
                                render: (err) => (
                                  <Box>
                                    <Text color="red.700">{err}</Text>
                                  </Box>
                                ),
                              },
                            ]}
                            pageSize={4}
                            rows={pipelineRootErrors}
                          />
                        </Flex>
                      ) : null}
                    </Grid>
                  </Box>
                );
              })}
            </Fragment>
          );
        })}
      </Flex>
    );
  } else return null;
}
